import MasterDepartment from "./Department";

export default MasterDepartment;
